import { tourCrudConfig } from '@/config/objects/tours';
import { CrudListView, PageContainer } from '@startupquickstart/frontend';

/**
 * Tours list page
 */
export function ToursPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Tours', current: true },
  ];

  return (
    <PageContainer>
      <CrudListView config={tourCrudConfig} baseUrl="/tours" breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
